export enum OnBoarding {
  ON_BOARDING_INFO = 'onboardingInfo',
  ON_BOARDING_EXPLORE = 'onboarding_explore',
  }
